import type { ComponentChildren, CSSProperties, JSX } from "preact";
import { classNames } from "@gss/common/classNames";
import { objectEntries } from "@gss/common/objectUtil";

type Breakpoint = "xs" | "sm" | "md" | "lg" | "xl" | "xxl";
type BreakpointValue =
    | boolean
    | "auto"
    | "1"
    | "2"
    | "3"
    | "4"
    | "5"
    | "6"
    | "7"
    | "8"
    | "9"
    | "10"
    | "11"
    | "12";
type Breakpoints = Partial<Record<Breakpoint, BreakpointValue>>;

type Props = {
    className?: string;
    style?: CSSProperties;
    children?: ComponentChildren;
} & Breakpoints;

export function Col({
    className,
    style,
    children,
    ...breakpoints
}: Props): JSX.Element {
    return (
        <div
            className={classNames(getColClass(breakpoints), className)}
            style={style}
        >
            {children}
        </div>
    );
}

function getColClass(breakpoints: Breakpoints): string {
    const classes: string[] = [];

    for (const [breakpoint, value] of objectEntries(breakpoints)) {
        const cls = getBreakpointClass(breakpoint, value);
        if (cls != null) {
            classes.push(cls);
        }
    }

    if (classes.length === 0) {
        return "col";
    }

    return classes.join(" ");
}

function getBreakpointClass(
    breakpoint: Breakpoint,
    value: BreakpointValue,
): string | undefined {
    const prefix = breakpoint === "xs" ? "col" : `col-${breakpoint}`;

    // oxlint-disable-next-line typescript/switch-exhaustiveness-check
    switch (value) {
        case false:
            return undefined;
        case true:
            return prefix;
        case "auto":
            return `${prefix}-auto`;
        default:
            return `${prefix}-${value}`;
    }
}
